import { Box, RadioGroup, Typography } from "@mui/material";
import { FC, useCallback } from "react";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { ICPAnalysisMethod } from "../../types";
import { ICPCustomerListMethodOption } from "./CustomerList/ICPCustomerListMethodOption";
import { ICPProductBasedMethodOption } from "./ProductBased/ICPProductBasedMethodOption";

interface ICPAnalysisMethodSelectorProps {
  /** Callback to switch to analysis tab */
  onViewAnalysis: () => void;
}

/**
 * ICP Analysis Method Selector component
 * Allows users to choose between product-based analysis and customer list upload
 */
export const ICPAnalysisMethodSelector: FC<ICPAnalysisMethodSelectorProps> = ({
  onViewAnalysis,
}) => {
  const icpAnalysisMethod = useWorkspaceStore(
    (state) => state.icpAnalysisMethod
  );

  const setICPAnalysisMethod = useWorkspaceStore(
    (state) => state.setICPAnalysisMethod
  );
  const saveICPToDraft = useWorkspaceStore((state) => state.saveICPToDraft);

  const handleMethodChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const method = event.target.value as ICPAnalysisMethod;
      setICPAnalysisMethod(method);
      saveICPToDraft();
    },
    [setICPAnalysisMethod, saveICPToDraft]
  );

  return (
    <Box sx={{ padding: "30px" }}>
      <Typography variant="h4" textTransform="capitalize">
        Select an analysis method
      </Typography>
      <RadioGroup
        value={icpAnalysisMethod}
        onChange={handleMethodChange}
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr  1fr",
          maxWidth: "1280px",
        }}
      >
        <ICPProductBasedMethodOption
          selectedMethod={icpAnalysisMethod}
          onViewAnalysis={onViewAnalysis}
        />
        <ICPCustomerListMethodOption
          selectedMethod={icpAnalysisMethod}
          onViewAnalysis={onViewAnalysis}
        />
      </RadioGroup>
    </Box>
  );
};
